import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeopleRemove2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPeopleRemove2"><Path d="M6.49963 6.5C6.49963 4.01472 8.51435 2 10.9996 2C13.4849 2 15.4996 4.01472 15.4996 6.5C15.4996 8.98528 13.4849 11 10.9996 11C8.51435 11 6.49963 8.98528 6.49963 6.5Z" fill="currentColor"/><Path d="M2.75289 20.1798C3.15432 15.9097 6.38371 12.5 10.9996 12.5C15.6155 12.5 18.8449 15.9097 19.2463 20.1798L19.3234 21H2.67578L2.75289 20.1798Z" fill="currentColor"/><Path d="M22.9996 10.5H16.9996V12H22.9996V10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeopleRemove2;
